// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../../shared/material.module';
import { SharedModule } from '../../../shared/shared.module';
import { CreateDealSummaryComponentComponent } from './create-deal-summary-component/create-deal-summary-component.component';
import { CreateDealComponent } from './create-deal.component';
import { CustomerFormComponent } from './customer-form/customer-form.component';
import { TradeInFormComponent } from './trade-in-form/trade-in-form.component';
import { VehicleManualFormComponent } from './vehicle-manual-form/vehicle-manual-form-component';

@NgModule({
    declarations: [CreateDealComponent, CustomerFormComponent, VehicleManualFormComponent, CreateDealSummaryComponentComponent, TradeInFormComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule, SharedModule],
    exports: [CustomerFormComponent, SharedModule],
})
export class CreateDealModule {}
